import { IAppState } from '../../redux';
import { EBillingStatus } from '../../services/billingPayments';

export const isBillingUnstable = (state: IAppState) => {
  return state.billingStatus.status === EBillingStatus.UNSTABLE;
};
